module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_ohanabatake-72fdb85299f422ceb6aba51c42d20d36.jpg";